import React from 'react';
import { useMount } from '../hooks';
import analytics from '../modules/analytics';

export const TrackOnMount: React.FC<{ event: string, params?: object }> = ({
  event,
  params,
}) => {
  useMount(() => {
    analytics.track(event, params);
  });

  return null;
};
